// Place this file inside your utility/ folder, next to countrycode.json,
// so the import below never breaks regardless of which page imports this file.
import {
	parsePhoneNumberFromString,
	getExampleNumber,
} from "libphonenumber-js";
import examples from "libphonenumber-js/examples.mobile.json";
import countrydata from "./countrycode.json";

const DIAL_TO_ISO = {};
countrydata.forEach((item) => {
	const iso =
		item.code || item.iso || item.iso2 || item.countryCode || null;
	if (iso && item.dial_code && !DIAL_TO_ISO[item.dial_code]) {
		DIAL_TO_ISO[item.dial_code] = iso.toUpperCase();
	}
});

// some dial codes are shared by multiple countries (e.g. +1 = US, Canada, and 10+ Caribbean
// islands). These overrides force the most commonly-intended country for validation purposes.
const AMBIGUOUS_DIAL_CODE_OVERRIDES = {
	"+1": "US",
	"+44": "GB",
	"+61": "AU",
	"+7": "RU",
};
Object.assign(DIAL_TO_ISO, AMBIGUOUS_DIAL_CODE_OVERRIDES);

const getIsoFromDialCode = (dialCode) => DIAL_TO_ISO[dialCode] || null;

// max length -- based on a real MOBILE example number for that country
export const getPhoneMaxLength = (dialCode) => {
	const iso = getIsoFromDialCode(dialCode);
	if (!iso) return 15;
	try {
		const example = getExampleNumber(iso, examples);
		return example ? example.nationalNumber.length : 15;
	} catch {
		return 15;
	}
};

// validates a raw national number string (no dial code prefix) against the selected dial code.
// IMPORTANT: libphonenumber-js's isValid() checks against ALL number types for that country
// (mobile, landline, toll-free, premium-rate etc). Many countries (India included) have
// landline numbers of varying digit lengths, so a too-short/too-long number can still pass
// isValid() by accidentally matching some other valid type. To keep this strictly "this is a
// real mobile-length number", we additionally require the digit count to match the expected
// mobile-number length for that country.
export const validatePhoneNumber = (number, dialCode) => {
	if (!number || !dialCode) return false;

	const iso = getIsoFromDialCode(dialCode);
	if (!iso) return false;

	const digitsOnly = number.replace(/\D/g, "");
	const expectedLength = getPhoneMaxLength(dialCode);

	if (digitsOnly.length !== expectedLength) return false;

	try {
		const parsed = parsePhoneNumberFromString(number, iso);
		return parsed ? parsed.isValid() : false;
	} catch {
		return false;
	}
};

export const getPhoneErrorMessage = (label, dialCode) => {
	const iso = getIsoFromDialCode(dialCode);
	if (!iso) return `${label} is invalid for the selected country code.`;
	const maxLen = getPhoneMaxLength(dialCode);
	return `${label} must be exactly ${maxLen} digits for the selected country code.`;
};